export default {
  "be.accessStatsPermissionsError": "Sorry, you do not have permission to see the access stats for this file.",
  "be.activityFeed.fullDateTime": "{time, date, full} at {time, time, short}",
  "be.activityFeedItemApiError": "There was a problem loading the activity feed. Please refresh the page or try again later.",
  "be.activitySidebar.activityFeed.annotationMissingError": "This comment no longer exists",
  "be.activitySidebar.activityFeed.commentMissingError": "This comment no longer exists",
  "be.activitySidebar.activityFeed.feedInlineErrorTitle": "Error",
  "be.activitySidebar.activityFeed.hideReplies": "Hide replies",
  "be.activitySidebar.activityFeed.reply": "Reply",
  "be.activitySidebar.activityFeed.replyInThread": "Reply in thread",
  "be.activitySidebar.activityFeed.showReplies": "See {repliesToLoadCount, plural, one {# reply} other {# replies}}",
  "be.activitySidebar.activityFeed.taskMissingError": "This task no longer exists",
  "be.activitySidebarFilter.status.allActivity": "All Activity",
  "be.activitySidebarFilter.status.allComments": "All Comments",
  "be.activitySidebarFilter.status.open": "Unresolved Comments",
  "be.activitySidebarFilter.status.resolved": "Resolved Comments",
  "be.activitySidebarFilter.status.tasks": "Tasks",
  "be.add": "Add",
  "be.additionalTab.blockedByShieldAccessPolicy": "Use of this app is blocked due to a security policy.",
  "be.api.appActivityDeleteErrorMessage": "There was an error deleting this item.",
  "be.api.commentCreateConflictMessage": "This comment already exists.",
  "be.api.commentCreateErrorMessage": "There was an error creating this comment.",
  "be.api.commentDeleteErrorMessage": "There was an error deleting this comment.",
  "be.api.commentUpdateErrorMessage": "This comment could not be modified.",
  "be.api.repliesFetchErrorMessage": "The replies to this comment could not be loaded.",
  "be.api.taskActionErrorTitle": "Error",
  "be.api.taskApproveErrorMessage": "An error has occurred while approving this task. Please refresh the page and try again.",
  "be.api.taskCompleteErrorMessage": "An error has occurred while completing this task. Please refresh the page and try again.",
  "be.api.taskCreateErrorMessage": "An error occurred while creating this task. Please try again.",
  "be.api.taskDeleteErrorMessage": "There was an error while deleting this task. Please refresh the page and try again.",
  "be.api.taskGroupExceedsWarningTitle": "One or more groups can not receive this task as a group size cannot exceed the limit of {max} assignees per group.",
  "be.api.taskRejectErrorMessage": "An error has occurred while rejecting this task. Please refresh the page and try again.",
  "be.appActivity.altIcon": "{appActivityName} Icon",
  "be.appActivity.deleteMenuItem": "Delete",
  "be.appActivity.deletePrompt": "Are you sure you want to permanently delete this app activity?",
  "be.back": "Back",
  "be.bookmark": "Bookmark",
  "be.boxEditBlacklistedError": "This file cannot be opened locally",
  "be.boxEditErrorBlockedByPolicy": "Local editing of this content has been disabled based on an access policy",
  "be.boxToolsInstallMessage": "Install {boxTools} to open this file on your desktop",
  "be.cancel": "Cancel",
  "be.choose": "Choose",
  "be.close": "Close",
  "be.collaboratedFolder": "Collaborated Folder",
  "be.collapse": "Collapse",
  "be.complete": "Complete",
  "be.contentInsights.contentAnalyticsErrorText": "There was a problem loading content insights. Please try again.",
  "be.contentInsights.contentAnalyticsPermissionError": "Oops! You no longer have access to view content insights.",
  "be.contentInsights.contentInsightsTitle": "Content Insights",
  "be.contentInsights.downloadGraphLabel": "Chart displaying the number of downloads over the selected time period",
  "be.contentInsights.downloadGraphType": "DOWNLOADS",
  "be.contentInsights.openContentInsightsButton": "See Details",
  "be.contentInsights.peopleGraphLabel": "Chart displaying the number of users over the selected time period",
  "be.contentInsights.peopleTitle": "PEOPLE",
  "be.contentInsights.previewGraphLabel": "Chart displaying the number of previews over the selected time period",
  "be.contentInsights.previewGraphType": "PREVIEWS",
  "be.contentInsights.trendDown": "Trending down",
  "be.contentInsights.trendMonth": "PAST MONTH",
  "be.contentInsights.trendThreeMonths": "PAST 3 MONTHS",
  "be.contentInsights.trendUp": "Trending up",
  "be.contentInsights.trendWeek": "PAST WEEK",
  "be.contentInsights.trendYear": "PAST YEAR",
  "be.contentSharing.badRequestError": "The request for this item was malformed.",
  "be.contentSharing.collaboratorsLoadingError": "Could not retrieve collaborators for this item.",
  "be.contentSharing.getContactsError": "Could not retrieve contacts.",
  "be.contentSharing.loadingError": "Could not load shared link for this item.",
  "be.contentSharing.noAccessError": "You do not have access to this item.",
  "be.contentSharing.notFoundError": "Could not find shared link for this item.",
  "be.contentSharing.sendInvitesError": "Could not send invites.",
  "be.contentSharing.sendInvitesSuccess": "Successfully invited collaborators.",
  "be.contentSharing.sharedLinkRemovalSuccess": "The shared link for this item was removed.",
  "be.contentSharing.sharedLinkSettingsUpdateSuccess": "The shared link for this item was successfully updated.",
  "be.contentSharing.sharedLinkUpdateError": "Could not update the shared link for this item.",
  "be.contentSidebar.activityFeed.annotationActivity.annotationActivityDeleteMenuItem": "Delete",
  "be.contentSidebar.activityFeed.annotationActivity.annotationActivityDeletePrompt": "Are you sure you want to permanently delete this comment?",
  "be.contentSidebar.activityFeed.annotationActivity.annotationActivityEditMenuItem": "Modify",
  "be.contentSidebar.activityFeed.annotationActivity.annotationActivityPostedFullDateTime": "{time, date, full} at {time, time, short}",
  "be.contentSidebar.activityFeed.annotationActivity.annotationActivityResolveMenuItem": "Resolve",
  "be.contentSidebar.activityFeed.annotationActivity.annotationActivityUnresolveMenuItem": "Unresolve",
  "be.contentSidebar.activityFeed.annotationActivityPageItem": "Page {number}",
  "be.contentSidebar.activityFeed.annotationActivityVersionLink": "Version {number}",
  "be.contentSidebar.activityFeed.annotationActivityVersionUnavailable": "Version Unavailable",
  "be.contentSidebar.activityFeed.comment.commentDeleteMenuItem": "Delete",
  "be.contentSidebar.activityFeed.comment.commentDeletePrompt": "Are you sure you want to permanently delete this comment?",
  "be.contentSidebar.activityFeed.comment.commentEditMenuItem": "Modify",
  "be.contentSidebar.activityFeed.comment.commentPostedFullDateTime": "{time, date, full} at {time, time, short}",
  "be.contentSidebar.activityFeed.comment.commentResolveMenuItem": "Resolve",
  "be.contentSidebar.activityFeed.comment.commentUnresolveMenuItem": "Unresolve",
  "be.contentSidebar.activityFeed.comment.hideReplies": "Hide replies",
  "be.contentSidebar.activityFeed.comment.inlineCommentAnnotationIconTitle": "Inline Comment",
  "be.contentSidebar.activityFeed.comment.reply": "Reply",
  "be.contentSidebar.activityFeed.comment.replyInThread": "Reply in thread",
  "be.contentSidebar.activityFeed.comment.showReplies": "See {repliesToLoadCount, plural, one {# reply} other {# replies}}",
  "be.contentSidebar.activityFeed.commentForm.approvalAddAssignee": "Add an assignee",
  "be.contentSidebar.activityFeed.commentForm.approvalAddTask": "Add Task",
  "be.contentSidebar.activityFeed.commentForm.approvalAddTaskTooltip": "Assigning a task to someone will send them a notification with the message in the comment box and allow them to approve or deny.",
  "be.contentSidebar.activityFeed.commentForm.approvalAssignees": "Assignees",
  "be.contentSidebar.activityFeed.commentForm.approvalDueDate": "Due Date",
  "be.contentSidebar.activityFeed.commentForm.approvalSelectDate": "Select a date",
  "be.contentSidebar.activityFeed.commentForm.atMentionTip": "@mention users to notify them.",
  "be.contentSidebar.activityFeed.commentForm.atMentionTipDescription": "Use the @ symbol to mention users and use the up and down arrow keys to scroll through autocomplete suggestions.",
  "be.contentSidebar.activityFeed.commentForm.commentCancel": "Cancel",
  "be.contentSidebar.activityFeed.commentForm.commentLabel": "Write a comment",
  "be.contentSidebar.activityFeed.commentForm.commentPost": "Post",
  "be.contentSidebar.activityFeed.commentForm.commentWrite": "Write a comment",
  "be.contentSidebar.activityFeed.commmon.showOriginalMessage": "Show Original",
  "be.contentSidebar.activityFeed.common.activityStatusResolved": "RESOLVED",
  "be.contentSidebar.activityFeed.common.editedMessage": " (edited)",
  "be.contentSidebar.activityFeed.common.seeLessMessage": "See less",
  "be.contentSidebar.activityFeed.common.seeMoreMessage": "See more",
  "be.contentSidebar.activityFeed.common.translateMessage": "Translate",
  "be.contentSidebar.activityFeed.task.approvalTaskAnnotationIconTitle": "Approval Task",
  "be.contentSidebar.activityFeed.task.generalTaskAnnotationIconTitle": "General Task",
  "be.contentSidebar.activityFeed.task.taskAnyAffordanceTooltip": "Only one assignee is required to complete this task",
  "be.contentSidebar.activityFeed.task.taskDeleteMenuItem": "Delete task",
  "be.contentSidebar.activityFeed.task.taskDeletePrompt": "Are you sure you want to permanently delete this task?",
  "be.contentSidebar.activityFeed.task.taskEditMenuItem": "Modify task",
  "be.contentSidebar.activityFeed.task.taskMultipleFilesAffordanceTooltip": "There are multiple files associated with this task",
  "be.contentSidebar.activityFeed.taskForm.taskAnyCheckboxLabel": "Only one assignee is required to complete this task",
  "be.contentSidebar.activityFeed.taskForm.taskAnyInfoGroupTooltip": "Selecting this option will require only one assignee to complete this task. This will include assignees across all groups.",
  "be.contentSidebar.activityFeed.taskForm.taskAnyInfoTooltip": "By default, all assignees are required to take action before a task is complete. Selecting this option will require only one assignee to complete this task.",
  "be.contentSidebar.activityFeed.taskForm.taskApprovalAssigneeRemovalWarningMessage": "Unable to remove assignee(s) because the task is now approved.",
  "be.contentSidebar.activityFeed.taskForm.taskCreateErrorTitle": "Error",
  "be.contentSidebar.activityFeed.taskForm.taskCreateGroupLabel": "Group",
  "be.contentSidebar.activityFeed.taskForm.taskEditWarningTitle": "Task Updated with Errors",
  "be.contentSidebar.activityFeed.taskForm.taskGeneralAssigneeRemovalWarningMessage": "Unable to remove assignee(s) because the task is now completed.",
  "be.contentSidebar.activityFeed.taskForm.taskGroupExceedsWarningTitle": "Exceeded max assignees per group",
  "be.contentSidebar.activityFeed.taskForm.taskUpdateErrorMessage": "An error occurred while modifying this task. Please try again.",
  "be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormCancelLabel": "Cancel",
  "be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormDueDateLabel": "Due Date",
  "be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormMessageLabel": "Message",
  "be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormSelectAssigneesLabel": "Select Assignees",
  "be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormSubmitLabel": "Create",
  "be.contentSidebar.activityFeed.taskForm.tasksEditTaskFormSubmitLabel": "Update",
  "be.contentSidebar.activityFeed.taskNew.taskAssignmentCompleted": "Completed",
  "be.contentSidebar.activityFeed.taskNew.taskCollaboratorLoadErrorMessage": "An error has occurred while loading collaborators for this task. Please try again.",
  "be.contentSidebar.activityFeed.taskNew.taskDueDateLabel": "Due: {date}",
  "be.contentSidebar.activityFeed.taskNew.taskFeedStatusDue": "DUE {dateTime}",
  "be.contentSidebar.activityFeed.taskNew.taskShowLessAssignees": "Show Less",
  "be.contentSidebar.activityFeed.taskNew.taskShowMoreAssignees": "Show {additionalAssigneeCount} More",
  "be.contentSidebar.activityFeed.taskNew.taskShowMoreAssigneesOverflow": "{additionalAssigneeCount, plural, one {Show #+ More} other {Show #+ More}}",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedApproveAction": "Approve",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedApprovedLabel": "Approved",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedApprovedUppercaseLabel": "APPROVED",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedAssigneeListTitle": "Assignees",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedCompleteAction": "Mark as Complete",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedCompletedLabel": "Completed",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedCompletedUppercaseLabel": "COMPLETED",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineApproval": "{user} assigned an Approval Task",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineApprovalCurrentUser": "{user} assigned you an Approval Task",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineGeneral": "{user} assigned a Task",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineGeneralCurrentUser": "{user} assigned you a Task",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedInProgressLabel": "In Progress",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedInProgressUppercaseLabel": "IN PROGRESS",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedMoreAssigneesLabel": "See all assignees",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedRejectAction": "Reject",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedRejectedLabel": "Rejected",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedRejectedUppercaseLabel": "REJECTED",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedStatusApproved": "Approved {dateTime}",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedStatusCompleted": "Completed {dateTime}",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedStatusRejected": "Rejected {dateTime}",
  "be.contentSidebar.activityFeed.taskNew.tasksFeedViewDetailsAction": "View Task Details",
  "be.contentSidebar.addTask": "Add Task",
  "be.contentSidebar.addTask.approval": "Approval Task",
  "be.contentSidebar.addTask.approval.description": "Assignees will be responsible for approving or rejecting tasks",
  "be.contentSidebar.addTask.approval.title": "Create Approval Task",
  "be.contentSidebar.addTask.general": "General Task",
  "be.contentSidebar.addTask.general.description": "Assignees will be responsible for marking tasks as complete",
  "be.contentSidebar.addTask.general.title": "Create General Task",
  "be.contentSidebar.boxAI.expand": "Expand",
  "be.contentSidebar.boxSignFtuxBody": "Sign documents or send signature requests, right from where your content lives",
  "be.contentSidebar.boxSignFtuxTitle": "Box Sign - Secure, seamless e-signatures in Box",
  "be.contentSidebar.boxSignRequest": "Request Signature",
  "be.contentSidebar.boxSignRequestSignature": "Request Signature",
  "be.contentSidebar.boxSignSecurityBlockedTooltip": "This action is unavailable due to a security policy.",
  "be.contentSidebar.boxSignSignMyself": "Sign Myself",
  "be.contentSidebar.boxSignSignature": "Sign",
  "be.contentSidebar.boxSignWatermarkBlockedTooltip": "This action is unavailable, because the file is watermarked.",
  "be.contentSidebar.editTask.approval.title": "Modify Approval Task",
  "be.contentSidebar.editTask.general.title": "Modify General Task",
  "be.copy": "Copy",
  "be.create": "Create",
  "be.createDialogErrorInUse": "A folder with the same name already exists.",
  "be.createDialogErrorInvalid": "This is an invalid folder name.",
  "be.createDialogErrorTooLong": "This folder name is too long.",
  "be.createDialogLabel": "New Folder",
  "be.createDialogText": "Please enter a name.",
  "be.currentUserErrorHeaderMessage": "Something went wrong when fetching the current user.",
  "be.dateASC": "Date: Oldest → Newest",
  "be.dateDESC": "Date: Newest → Oldest",
  "be.defaultErrorMaskHeaderMessage": "We’re sorry, something went wrong.",
  "be.defaultErrorMaskSubHeaderMessage": "Please refresh the page or try again later.",
  "be.defaultInlineErrorContentMessage": "Please try again later.",
  "be.defaultOpenWithDescription": "Open this file with a partner service",
  "be.defaultSkill": "Skill Card",
  "be.delete": "Delete",
  "be.deleteDialogFileText": "Are you sure you want to delete {name}?",
  "be.deleteDialogFolderText": "Are you sure you want to delete {name} and all its contents?",
  "be.deleteDialogLabel": "Confirm Delete",
  "be.description": "Description",
  "be.descriptionPlaceholder": "Enter a description",
  "be.docGenSidebar.docGenTags": "Doc Gen Tags",
  "be.docGenSidebar.emptyTags": "This document has no tags",
  "be.docGenSidebar.errorTags": "We couldn't load the tags",
  "be.docGenSidebar.imageTags": "Image tags",
  "be.docGenSidebar.refreshButton": "Refresh",
  "be.docGenSidebar.refreshPrompt": "Please refresh the list.",
  "be.docGenSidebar.textTags": "Text tags",
  "be.download": "Download",
  "be.drawAnnotation": "Drawing annotation mode",
  "be.editLabel": "Edit",
  "be.emptyOpenWithDescription": "No integrations are available for this file",
  "be.error": "Error",
  "be.errorBreadcrumb": "Error",
  "be.errorOccured": "An error occurred",
  "be.errorOpenWithDescription": "Opening this file with other services is currently unavailable",
  "be.errorState": "A network error has occurred while trying to load.",
  "be.executeIntegrationOpenWithErrorHeader": "We’re sorry, this integration is currently unavailable.",
  "be.executeIntegrationOpenWithErrorSubHeader": "Please try again later.",
  "be.expand": "Expand",
  "be.externalFolder": "External Folder",
  "be.faceSkill": "Faces",
  "be.file": "File",
  "be.fileAccessStatsErrorHeaderMessage": "Something went wrong when fetching the access stats.",
  "be.fileClassificationErrorHeaderMessage": "Something went wrong when fetching classification.",
  "be.fileDescriptionInlineErrorTitleMessage": "Something went wrong when saving the description.",
  "be.fileRequestDisplayName": "File Request",
  "be.folder": "Folder",
  "be.folderState": "There are no items in this folder.",
  "be.getVersionInfo": "Get version information",
  "be.gridView": "Switch to Grid View",
  "be.gridView.columnSize": "Column size",
  "be.gridView.decreaseColumnSize": "Decrease column size",
  "be.gridView.increaseColumnSize": "Increase column size",
  "be.in": "In",
  "be.interactedDate": "Last accessed on {date}",
  "be.itemCreated": "Created",
  "be.itemInteracted": "Last Accessed",
  "be.itemModified": "Modified",
  "be.itemName": "Name",
  "be.itemOwner": "Owner",
  "be.itemSize": "Size",
  "be.itemUploader": "Uploader",
  "be.keywordSkill": "Topics",
  "be.keywordsAppliedList": "Keywords were applied",
  "be.keywordsList": "Keywords: {words}",
  "be.listView": "Switch to List View",
  "be.loading": "Loading",
  "be.loadingState": "Please wait while the items load...",
  "be.logo": "Logo",
  "be.max": "max",
  "be.metadataState": "There are no items in this folder.",
  "be.modifiedDate": "Modified {date}",
  "be.modifiedDateBy": "Modified {date} by {name}",
  "be.moreOptions": "More options",
  "be.nameASC": "Name: A → Z",
  "be.nameDESC": "Name: Z → A",
  "be.nameDate": "{date} by {name}",
  "be.newFolder": "New Folder",
  "be.nextFile": "Next File",
  "be.nextSegment": "Next Segment",
  "be.noActivity": "No activity to show",
  "be.noActivityAnnotationPrompt": "Hover over the preview and use the controls at the bottom to annotate the file.",
  "be.noActivityCommentPrompt": "Comment and @mention people to notify them.",
  "be.open": "Open",
  "be.pagination.nextPage": "Next Page",
  "be.pagination.pageStatus": "{pageNumber} of {pageCount}",
  "be.pagination.previousPage": "Previous Page",
  "be.personalFolder": "Personal Folder",
  "be.pointAnnotation": "Point annotation mode",
  "be.preview": "Preview",
  "be.previewError": "This preview didn’t load. Please try to open or download the file to view.",
  "be.previewErrorBlockedByPolicy": "Your access to this content is restricted due to a security policy.",
  "be.previewUpdate": "A new version of this file is available.",
  "be.previousFile": "Previous File",
  "be.previousSegment": "Previous Segment",
  "be.print": "Print",
  "be.priorCollaborator": "A Prior Collaborator",
  "be.recentsBreadcrumb": "Recents",
  "be.recentsState": "There are no recent items yet.",
  "be.reload": "Reload",
  "be.remove": "Remove",
  "be.rename": "Rename",
  "be.renameDialogErrorInUse": "An item with the same name already exists.",
  "be.renameDialogErrorInvalid": "This name is invalid.",
  "be.renameDialogErrorTooLong": "This name is too long.",
  "be.renameDialogLabel": "Rename",
  "be.renameDialogText": "Please enter a new name for {name}:",
  "be.resume": "Resume",
  "be.resumeAll": "Resume All",
  "be.retry": "Retry",
  "be.rootBreadcrumb": "All Files",
  "be.save": "Save",
  "be.searchBreadcrumb": "Search Results",
  "be.searchPlaceholder": "Search files and folders",
  "be.searchState": "Sorry, we couldn’t find what you’re looking for.",
  "be.selected": "{count} Selected",
  "be.selectedBreadcrumb": "Selected Items",
  "be.selectedState": "You haven’t selected any items yet.",
  "be.share": "Share",
  "be.shareAccessCollab": "Access: People in this folder",
  "be.shareAccessCompany": "People in this company",
  "be.shareAccessNone": "No shared link",
  "be.shareAccessOpen": "Access: People with the link",
  "be.shareAccessRemove": "Remove shared link",
  "be.shareDialogLabel": "Share",
  "be.shareDialogNone": "None",
  "be.shareDialogText": "Shared Link:",
  "be.sidebarAccessStats": "Access Stats",
  "be.sidebarActivityTitle": "Activity",
  "be.sidebarBoxAITitle": "Box AI",
  "be.sidebarContentInsights": "Content Insights",
  "be.sidebarDetailsTitle": "Details",
  "be.sidebarDocGenTitle": "Doc Gen Tags",
  "be.sidebarDocGenTooltip": "Box Doc Gen",
  "be.sidebarFileFetchingErrorContent": "An error has occurred while fetching your Box file. Please refresh the page and try again.",
  "be.sidebarHide": "Hide Sidebar",
  "be.sidebarMetadataEditingErrorContent": "An error has occurred while updating metadata. Please refresh the page and try again.",
  "be.sidebarMetadataFetchingErrorContent": "An error has occurred while fetching metadata. Please refresh the page and try again.",
  "be.sidebarMetadataTitle": "Metadata",
  "be.sidebarNavLabel": "Sidebar",
  "be.sidebarProperties": "File Properties",
  "be.sidebarShow": "Show Sidebar",
  "be.sidebarSkillsErrorContent": "An error has occurred while updating skills. Please refresh the page and try again.",
  "be.sidebarSkillsErrorTitle": "Skills Error",
  "be.sidebarSkillsTitle": "Skills",
  "be.sidebarVersions.current": "Current Version",
  "be.sidebarVersions.delete": "Delete",
  "be.sidebarVersions.deleteError": "File version could not be deleted.",
  "be.sidebarVersions.deletedBy": "Deleted by {name}",
  "be.sidebarVersions.disabledByRetention": "Disabled by retention policy",
  "be.sidebarVersions.download": "Download",
  "be.sidebarVersions.downloadError": "File version could not be downloaded.",
  "be.sidebarVersions.empty": "No prior versions are available for this file.",
  "be.sidebarVersions.fetchError": "File versions could not be retrieved.",
  "be.sidebarVersions.fileRequestDisplayName": "File Request",
  "be.sidebarVersions.notAvailable": "Sorry, version history is not available with your current account plan. To access versioning, select from one of our paid plans.",
  "be.sidebarVersions.preview": "Preview",
  "be.sidebarVersions.priorWeek": "Last Week",
  "be.sidebarVersions.promote": "Make Current",
  "be.sidebarVersions.promoteError": "File version could not be made current.",
  "be.sidebarVersions.promotedBy": "Promoted from v{versionPromoted} by {name}",
  "be.sidebarVersions.restore": "Restore",
  "be.sidebarVersions.restoreError": "File version could not be restored.",
  "be.sidebarVersions.restoredBy": "Restored by {name}",
  "be.sidebarVersions.serverError": "Server Error",
  "be.sidebarVersions.thisMonth": "This Month",
  "be.sidebarVersions.title": "Version History",
  "be.sidebarVersions.today": "Today",
  "be.sidebarVersions.toggle": "Toggle Actions Menu",
  "be.sidebarVersions.upgradeButton": "Upgrade",
  "be.sidebarVersions.upgradeLink": "Upgrade Now",
  "be.sidebarVersions.uploadedBy": "Uploaded by {name}",
  "be.sidebarVersions.versionLimitExceeded": "You are limited to the last {versionLimit, number} {versionLimit, plural, one {version} other {versions}}.",
  "be.sidebarVersions.versionMaxEntries": "Version history is limited to the last {maxVersions} entries.",
  "be.sidebarVersions.versionNumberBadge": "V{versionNumber}",
  "be.sidebarVersions.versionNumberLabel": "Version number {versionNumber}",
  "be.sidebarVersions.versionRetentionDelete": "Will be deleted {time} by retention policy.",
  "be.sidebarVersions.versionRetentionIndefinite": "Retained indefinitely by retention policy.",
  "be.sidebarVersions.versionRetentionRemove": "Retention policy expires on {time}.",
  "be.sidebarVersions.versionUpsell": "Sorry, version history is not available with your current account plan. To access versioning, select from one of our paid plans.",
  "be.sidebarVersions.versionUserUnknown": "Unknown",
  "be.sidebarVersions.yesterday": "Yesterday",
  "be.sizeASC": "Size: Smallest → Largest",
  "be.sizeDESC": "Size: Largest → Smallest",
  "be.skillFileProcessingError": "We’re sorry, something went wrong with processing the file.",
  "be.skillInvalidFileExtensionError": "We’re sorry, no skills information was found. This file extension is currently not supported.",
  "be.skillInvalidFileSizeError": "We’re sorry, no skills information was found. This file size is currently not supported.",
  "be.skillInvokedStatus": "We’re preparing to process your file - please hold!",
  "be.skillNoInfoFoundError": "We’re sorry, no skills information was found.",
  "be.skillPendingStatus": "We’re working on processing your file - please hold!",
  "be.skillUnknownError": "Something went wrong with running this skill or fetching its data.",
  "be.sort": "Sort",
  "be.statusSkill": "Status",
  "be.today": "today",
  "be.topicsSkill": "Topics",
  "be.transcriptEdit": "Click any section to edit.",
  "be.transcriptSkill": "Transcript",
  "be.upload": "Upload",
  "be.uploadEmptyFileInput": "Browse your device",
  "be.uploadEmptyFolderInput": "Select Folders",
  "be.uploadEmptyState": "Empty state",
  "be.uploadEmptyWithFolderUploadDisabled": "Drag and drop files",
  "be.uploadEmptyWithFolderUploadEnabled": "Drag and drop files and folders",
  "be.uploadError": "A network error has occurred while trying to upload.",
  "be.uploadErrorState": "Error state",
  "be.uploadErrorTooManyFiles": "You can only upload up to {fileLimit} file(s) at a time.",
  "be.uploadInProgress": "Drag and drop to add additional files",
  "be.uploadNoDragDrop": "Select files from your device",
  "be.uploadOptions": "{option1} or {option2}",
  "be.uploadSuccess": "Success! Your files have been uploaded.",
  "be.uploadSuccessFileInput": "Select More Files",
  "be.uploadSuccessFolderInput": "Select More Folders",
  "be.uploadSuccessState": "Success state",
  "be.uploadsCancelButtonTooltip": "Cancel this upload",
  "be.uploadsDefaultErrorMessage": "Something went wrong with the upload. Please try again.",
  "be.uploadsFileSizeLimitExceededErrorMessage": "File size exceeds the folder owner’s file size limit",
  "be.uploadsFileSizeLimitExceededErrorMessageForUpgradeCta": "This file exceeds your plan’s upload limit. Upgrade now to store larger files.",
  "be.uploadsFileSizeLimitExceededUpgradeMessageForUpgradeCta": "Upgrade",
  "be.uploadsItemNameInUseErrorMessage": "A file with this name already exists.",
  "be.uploadsManagerUploadComplete": "Completed",
  "be.uploadsManagerUploadFailed": "Some Uploads Failed",
  "be.uploadsManagerUploadInProgress": "Uploading",
  "be.uploadsManagerUploadPrompt": "Drop files on this page to upload them into this folder.",
  "be.uploadsOneOrMoreChildFoldersFailedToUploadMessage": "One or more child folders failed to upload.",
  "be.uploadsPackageUploadErrorMessage": "Failed to upload package file. Please retry by saving as a single file.",
  "be.uploadsPendingFolderSizeLimitErrorMessage": "Pending app folder size limit exceeded",
  "be.uploadsProvidedFolderNameInvalidMessage": "Provided folder name, {name}, could not be used to create a folder.",
  "be.uploadsRetryButtonTooltip": "Retry upload",
  "be.uploadsStorageLimitErrorMessage": "Account storage limit reached",
  "be.versionDeleted": "{name} deleted v{version_number}",
  "be.versionMultipleUsersUploaded": "{numberOfCollaborators} collaborators uploaded v{versions}",
  "be.versionPromoted": "{name} promoted v{version_promoted} to v{version_number}",
  "be.versionRestored": "{name} restored v{version_number}",
  "be.versionUploadCollapsed": "{name} uploaded v{versions}",
  "be.versionUploaded": "{name} uploaded v{version_number}",
  "be.yesterday": "yesterday",
  "boxui.accessStats.accessStatsComments": "Comments",
  "boxui.accessStats.accessStatsDownloads": "Downloads",
  "boxui.accessStats.accessStatsEdits": "Edits",
  "boxui.accessStats.accessStatsPreviews": "Previews",
  "boxui.accessStats.accessStatsViewDetails": "View Details",
  "boxui.accessStats.accessStatsViews": "Views",
  "boxui.advancedContentInsights.advancedContentInsightsDescription": "Get actionable insights into how viewers are engaging with this content. Measure average time spent, page-by-page engagement, per person and per visit details.",
  "boxui.advancedContentInsights.advancedContentInsightsTitleDisabled": "Activate Engagement Insights",
  "boxui.advancedContentInsights.advancedContentInsightsTitleEnabled": "Engagement Insights is activated",
  "boxui.avatar.externalUser": "External user",
  "boxui.badges.beta": "BETA",
  "boxui.badges.trial": "TRIAL",
  "boxui.badges.upgrade": "UPGRADE",
  "boxui.base.nextMonth": "Next Month",
  "boxui.base.previousMonth": "Previous Month",
  "boxui.checkboxTooltip.iconInfoText": "Info",
  "boxui.classification.add": "Add",
  "boxui.classification.classification": "Classification",
  "boxui.classification.classificationDarkBlue": "Dark Blue",
  "boxui.classification.classificationGreen": "Green",
  "boxui.classification.classificationGrey": "Grey",
  "boxui.classification.classificationLightBlue": "Light Blue",
  "boxui.classification.classificationOrange": "Orange",
  "boxui.classification.classificationPurple": "Purple",
  "boxui.classification.classificationRed": "Red",
  "boxui.classification.classificationYellow": "Yellow",
  "boxui.classification.definition": "Definition",
  "boxui.classification.edit": "Edit",
  "boxui.classification.importedBy": "Imported from {modifiedBy} on {modifiedAt}",
  "boxui.classification.missing": "Not classified",
  "boxui.classification.modifiedBy": "Applied by {modifiedBy} on {modifiedAt}",
  "boxui.classification.modifiedByLabel": "Classification Label",
  "boxui.collaboratorAvatars.collaboration.pendingCollabText": "Pending",
  "boxui.collaboratorAvatars.collaboratorAvatarsLabel": "Shared with",
  "boxui.collaboratorAvatars.collaborators.expirationTooltipText": "Access expires on {date}",
  "boxui.collaboratorAvatars.collaborators.externalCollabTooltipText": "{email} is from outside of your company",
  "boxui.collaboratorAvatars.manageAllLinkText": "Manage All",
  "boxui.collaboratorAvatars.viewAdditionalPeopleText": "View additional people",
  "boxui.contentAnswers.contentAnswersTitle": "Box AI",
  "boxui.contentAnswers.defaultTooltip": "Get instant answers about this document using Box AI",
  "boxui.contentAnswers.disabledTooltipFileNotCompatible": "Box AI is not currently supported for this file type",
  "boxui.contentAnswers.documentSuggestedQuestionLabel1": "Summarize this document",
  "boxui.contentAnswers.documentSuggestedQuestionLabel2": "What are the key takeaways?",
  "boxui.contentAnswers.documentSuggestedQuestionLabel3": "How can this document be improved?",
  "boxui.contentAnswers.documentSuggestedQuestionLabel4": "Are there any next steps defined?",
  "boxui.contentAnswers.documentSuggestedQuestionPrompt1": "Summarize this document",
  "boxui.contentAnswers.documentSuggestedQuestionPrompt2": "What are the key takeaways?",
  "boxui.contentAnswers.documentSuggestedQuestionPrompt3": "How can this document be improved?",
  "boxui.contentAnswers.documentSuggestedQuestionPrompt4": "Are there any next steps defined?",
  "boxui.contentAnswers.hasQuestionsTooltip": "Return to Box AI",
  "boxui.contentAnswers.welcomeMessageSpreadsheetNotice": "Spreadsheet support works best for text dense files",
  "boxui.contentAnswers.welcomeMessageSpreadsheetNoticeAriaLabel": "spreadsheet support notification banner",
  "boxui.core.cancel": "Cancel",
  "boxui.core.close": "Close",
  "boxui.core.copied": "Copied",
  "boxui.core.copy": "Copy",
  "boxui.core.done": "Done",
  "boxui.core.guidetooltip.navigation": "{currentStepIndex} of {totalNumSteps}",
  "boxui.core.okay": "Okay",
  "boxui.core.optional": "optional",
  "boxui.core.save": "Save",
  "boxui.core.send": "Send",
  "boxui.datePicker.chooseDate": "Choose Date",
  "boxui.datePicker.dateClearButton": "Clear Date",
  "boxui.datePicker.dateInputMaxError": "Please enter a date before {maxLocaleDate}",
  "boxui.datePicker.dateInputMinError": "Please enter a date after {minLocaleDate}",
  "boxui.datePicker.dateInputRangeError": "Please enter a date between {minLocaleDate} and {maxLocaleDate}",
  "boxui.datePicker.iconAlertText": "Invalid Date",
  "boxui.draftjs.mentionSelector.noUsersFound": "No users found",
  "boxui.draftjs.mentionSelector.startMention": "Mention someone to notify them",
  "boxui.draftjs.mentionSelector.usersFound": "{usersCount, plural, one {one user found} other {{usersCount} users found}}",
  "boxui.errorMask.iconSadCloudText": "Sad Box Cloud",
  "boxui.itemDetails.archived": "Archived",
  "boxui.itemDetails.bookmarkExpiration": "This bookmark will be deleted on {expiration}.",
  "boxui.itemDetails.created": "Created",
  "boxui.itemDetails.deleted": "Deleted",
  "boxui.itemDetails.description": "Description",
  "boxui.itemDetails.descriptionPlaceholder": "Enter a description",
  "boxui.itemDetails.enterpriseOwner": "Enterprise Owner",
  "boxui.itemDetails.fileExpiration": "This file will be deleted on {expiration}.",
  "boxui.itemDetails.folderExpiration": "This folder will be deleted on {expiration}.",
  "boxui.itemDetails.modified": "Modified",
  "boxui.itemDetails.owner": "Owner",
  "boxui.itemDetails.retentionPolicyDescription": "Policy",
  "boxui.itemDetails.retentionPolicyExpiration": "Policy Expiration",
  "boxui.itemDetails.retentionPolicyExtend": "Extend",
  "boxui.itemDetails.savedVersions": "{versionCount, number} Saved Versions",
  "boxui.itemDetails.sharedLinkExpiration": "This shared link will be disabled on {expiration}.",
  "boxui.itemDetails.size": "Size",
  "boxui.itemDetails.uploader": "Uploader",
  "boxui.itemDetails.url": "URL",
  "boxui.itemDetails.urlPlaceholder": "Enter a valid url",
  "boxui.media.menuButtonArialLabel": "Options",
  "boxui.metadataInstanceEditor.allAttributesAreHidden": "All attributes in this template have been hidden.",
  "boxui.metadataInstanceEditor.applyCascadePolicyText": "Apply template and its values to all new and existing items in this folder and its subfolders.",
  "boxui.metadataInstanceEditor.cannotApplyCascadePolicyText": "Cascade policy cannot be applied to custom metadata at this time.",
  "boxui.metadataInstanceEditor.cascadePolicyLearnMore": "Learn more",
  "boxui.metadataInstanceEditor.cascadePolicyModeQuestion": "In the case of conflicts when applying this template and its values to existing items, what would you like to do? This is a one time action.",
  "boxui.metadataInstanceEditor.cascadePolicyOverwriteMode": "Overwrite all existing template values",
  "boxui.metadataInstanceEditor.cascadePolicySkipMode": "Skip and keep all existing template values",
  "boxui.metadataInstanceEditor.customAdd": "Add",
  "boxui.metadataInstanceEditor.customErrorDuplicateKey": "A field with that key already exists.",
  "boxui.metadataInstanceEditor.customErrorInternalKey": "Keys cannot begin with a $.",
  "boxui.metadataInstanceEditor.customErrorRequired": "A key is required.",
  "boxui.metadataInstanceEditor.customKey": "Key",
  "boxui.metadataInstanceEditor.customKeyPlaceholder": "e.g. Order Number",
  "boxui.metadataInstanceEditor.customNewField": "New Field",
  "boxui.metadataInstanceEditor.customNewFieldMessage": "Add a custom metadata field. Other people will be able to see and search for this field.",
  "boxui.metadataInstanceEditor.customRemove": "Remove",
  "boxui.metadataInstanceEditor.customTitle": "Custom Metadata",
  "boxui.metadataInstanceEditor.customValue": "Value",
  "boxui.metadataInstanceEditor.customValuePlaceholder": "e.g. 42",
  "boxui.metadataInstanceEditor.editTooltip": "Edit Metadata",
  "boxui.metadataInstanceEditor.enableCascadePolicy": "Enable Cascade Policy",
  "boxui.metadataInstanceEditor.fileMetadataRemoveCustomTemplateConfirm": "Are you sure you want to delete this custom metadata and all of its values from this file?",
  "boxui.metadataInstanceEditor.fileMetadataRemoveTemplateConfirm": "Are you sure you want to delete \"{metadataName}\" and all of its values from this file?",
  "boxui.metadataInstanceEditor.folderMetadataRemoveCustomTemplateConfirm": "Are you sure you want to delete this custom metadata and all of its values? Any metadata template values already applied to files in this folder will not be deleted.",
  "boxui.metadataInstanceEditor.folderMetadataRemoveTemplateConfirm": "Are you sure you want to delete \"{metadataName}\" and all of its values? Any metadata template values already applied to files in this folder will not be deleted.",
  "boxui.metadataInstanceEditor.invalidValue": "Invalid Input!",
  "boxui.metadataInstanceEditor.metadataCancel": "Cancel",
  "boxui.metadataInstanceEditor.metadataCascadePolicyEnabledInfo": "This template and its values are being cascaded to all items in this folder and its subfolders.",
  "boxui.metadataInstanceEditor.metadataSave": "Save",
  "boxui.metadataInstanceEditor.noAttributesForTemplate": "There are no attributes in this template.",
  "boxui.metadataInstanceEditor.noMetadata": "No Metadata Applied",
  "boxui.metadataInstanceEditor.noMetadataAddTemplate": "Click 'Add' in the top right to add metadata to this item",
  "boxui.metadataInstanceEditor.operationNotImmediate": "This operation is not immediate and may take some time.",
  "boxui.metadataInstanceEditor.removeTemplate": "Remove",
  "boxui.metadataInstanceEditor.templateAdd": "Add",
  "boxui.metadataInstanceEditor.templateSearchPlaceholder": "Search all templates",
  "boxui.metadataInstanceEditor.templatesFetchFailed": "Sorry! We could not fetch templates. Please contact your administrator",
  "boxui.metadataInstanceEditor.templatesNoRemainingTemplates": "All templates have been added",
  "boxui.metadataInstanceEditor.templatesNoResults": "No Results",
  "boxui.metadataInstanceEditor.templatesServerHasNoTemplates": "Zero templates",
  "boxui.metadataInstanceEditor.templatesTitle": "Templates",
  "boxui.metadataInstanceFields.customAdd": "Add",
  "boxui.metadataInstanceFields.customRemove": "Remove",
  "boxui.metadataInstanceFields.fieldMultiSelectValue": "Select Values",
  "boxui.metadataInstanceFields.fieldNoValue": "No Value",
  "boxui.metadataInstanceFields.fieldSelectValue": "Select Value",
  "boxui.metadataInstanceFields.fieldSetDate": "Set Date",
  "boxui.metadataInstanceFields.fieldSetValue": "Set Value",
  "boxui.metadataInstanceFields.invalidMetadataFieldType": "Invalid metadata field type!",
  "boxui.modalDialog.backModalText": "Back",
  "boxui.modalDialog.closeModalText": "Close Modal",
  "boxui.notification.clearNotification": "Clear Notification",
  "boxui.readableTime.eventTime": "{time, date, medium}",
  "boxui.readableTime.eventTimeDate": "{time, date, medium} at {time, time, short}",
  "boxui.readableTime.eventTimeDateShort": "{date} at {time, time, short}",
  "boxui.readableTime.eventTimeToday": "Today at {time, time, short}",
  "boxui.readableTime.eventTimeWeekdayLong": "{weekday}, {time, date, medium}",
  "boxui.readableTime.eventTimeYesterday": "Yesterday at {time, time, short}",
  "boxui.searchForm.clearButtonTitle": "Clear",
  "boxui.searchForm.searchButtonTitle": "Search",
  "boxui.searchForm.searchLabel": "Search query",
  "boxui.securityControls.allAppNames": "All applications: {appsList}",
  "boxui.securityControls.allIntegrationNames": "All integrations: {appsList}",
  "boxui.securityControls.appDownloadBlacklist": "Download restricted for some applications: {appNames}",
  "boxui.securityControls.appDownloadBlacklistOverflow": "Download restricted for some applications: {appNames} +{remainingAppCount} more",
  "boxui.securityControls.appDownloadRestricted": "Download restricted for some applications.",
  "boxui.securityControls.appDownloadWhitelist": "Only select applications are allowed: {appNames}",
  "boxui.securityControls.appDownloadWhitelistOverflow": "Only select applications are allowed: {appNames} +{remainingAppCount} more",
  "boxui.securityControls.boxSignRequestRestricted": "Sign restrictions apply.",
  "boxui.securityControls.desktopDownloadExternalOwners": "Download restricted on Box Drive, except Owners/Co-Owners. Also restricted for external users.",
  "boxui.securityControls.desktopDownloadExternalOwnersEditors": "Download restricted on Box Drive, except Owners/Co-Owners/Editors. Also restricted for external users.",
  "boxui.securityControls.desktopDownloadOwners": "Download restricted on Box Drive, except Owners/Co-Owners.",
  "boxui.securityControls.desktopDownloadOwnersEditors": "Download restricted on Box Drive, except Owners/Co-Owners/Editors.",
  "boxui.securityControls.downloadExternal": "Download restricted on Box Drive for external users.",
  "boxui.securityControls.externalCollabBlock": "External collaboration restricted.",
  "boxui.securityControls.externalCollabDomainList": "External collaboration limited to approved domains.",
  "boxui.securityControls.integrationDownloadAllowlist": "Only select integrations are allowed: {appNames}",
  "boxui.securityControls.integrationDownloadAllowlistOverflow": "Only select integrations are allowed: {appNames} +{remainingAppCount} more",
  "boxui.securityControls.integrationDownloadDenylist": "Download restricted for some integrations: {appNames}",
  "boxui.securityControls.integrationDownloadDenylistOverflow": "Download restricted for some integrations: {appNames} +{remainingAppCount} more",
  "boxui.securityControls.integrationDownloadRestricted": "Download restricted for some integrations.",
  "boxui.securityControls.mobileDownloadExternal": "Download restricted on mobile for external users.",
  "boxui.securityControls.mobileDownloadExternalOwners": "Download restricted on mobile, except Owners/Co-Owners. Also restricted for external users.",
  "boxui.securityControls.mobileDownloadExternalOwnersEditors": "Download restricted on mobile, except Owners/Co-Owners/Editors. Also restricted for external users.",
  "boxui.securityControls.mobileDownloadOwners": "Download restricted on mobile, except Owners/Co-Owners.",
  "boxui.securityControls.mobileDownloadOwnersEditors": "Download restricted on mobile, except Owners/Co-Owners/Editors.",
  "boxui.securityControls.modalDescription": "Classification labels defined by your administrator can be used to label content and apply security policies.",
  "boxui.securityControls.modalTitle": "View Classification for “{itemName}”",
  "boxui.securityControls.securityControlsLabel": "Restrictions",
  "boxui.securityControls.sharingCollabAndCompanyOnly": "Shared links cannot be made publicly accessible.",
  "boxui.securityControls.sharingCollabOnly": "Shared links allowed for collaborators only.",
  "boxui.securityControls.shortApp": "Application restrictions apply",
  "boxui.securityControls.shortAppSign": "App and Sign restrictions apply",
  "boxui.securityControls.shortDownload": "Download restrictions apply",
  "boxui.securityControls.shortDownloadApp": "Download and app restrictions apply",
  "boxui.securityControls.shortDownloadAppSign": "Download, app and Sign restrictions apply",
  "boxui.securityControls.shortDownloadIntegration": "Download and integration restrictions apply",
  "boxui.securityControls.shortDownloadIntegrationSign": "Download, integration and Sign restrictions apply",
  "boxui.securityControls.shortDownloadSign": "Download and Sign restrictions apply",
  "boxui.securityControls.shortIntegration": "Integration restrictions apply",
  "boxui.securityControls.shortIntegrationSign": "Integration and Sign restrictions apply",
  "boxui.securityControls.shortSharing": "Sharing restriction applies",
  "boxui.securityControls.shortSharingApp": "Sharing and app restrictions apply",
  "boxui.securityControls.shortSharingAppSign": "Sharing, app and Sign restrictions apply",
  "boxui.securityControls.shortSharingDownload": "Sharing and download restrictions apply",
  "boxui.securityControls.shortSharingDownloadApp": "Sharing, download and app restrictions apply",
  "boxui.securityControls.shortSharingDownloadAppSign": "Sharing, download, app and Sign restrictions apply",
  "boxui.securityControls.shortSharingDownloadIntegration": "Sharing, download and integration restrictions apply",
  "boxui.securityControls.shortSharingDownloadIntegrationSign": "Sharing, download, integration and Sign restrictions apply",
  "boxui.securityControls.shortSharingDownloadSign": "Sharing, download and Sign restrictions apply",
  "boxui.securityControls.shortSharingIntegration": "Sharing and integration restrictions apply",
  "boxui.securityControls.shortSharingIntegrationSign": "Sharing, integration and Sign restrictions apply",
  "boxui.securityControls.shortSharingSign": "Sharing and Sign restrictions apply",
  "boxui.securityControls.shortSign": "Sign restrictions apply",
  "boxui.securityControls.shortWatermarking": "Watermarking applies",
  "boxui.securityControls.viewAll": "View All",
  "boxui.securityControls.watermarkingApplied": "Watermarking will be applied.",
  "boxui.securityControls.webDownloadExternal": "Download restricted on web for external users.",
  "boxui.securityControls.webDownloadExternalOwners": "Download restricted on web, except Owners/Co-Owners. Also restricted for external users.",
  "boxui.securityControls.webDownloadExternalOwnersEditors": "Download restricted on web, except Owners/Co-Owners/Editors. Also restricted for external users.",
  "boxui.securityControls.webDownloadOwners": "Download restricted on web, except Owners/Co-Owners.",
  "boxui.securityControls.webDownloadOwnersEditors": "Download restricted on web, except Owners/Co-Owners/Editors.",
  "boxui.selectField.clearAll": "Clear All",
  "boxui.selectField.noResults": "No Results",
  "boxui.selectField.searchPlaceholder": "Search",
  "boxui.share.messageSelectorPlaceholder": "Add a message",
  "boxui.share.pillSelectorPlaceholder": "Add names or email addresses",
  "boxui.share.sharedLinkSettings.accessLevel.inCompanyView": "This content is available to anyone within your company with the link, and can be viewed.",
  "boxui.share.sharedLinkSettings.accessLevel.inCompanyViewDownload": "This content is available to anyone within your company with the link, and can be viewed or downloaded.",
  "boxui.share.sharedLinkSettings.accessLevel.inItem": "This content is available to invited collaborators with the link.",
  "boxui.share.sharedLinkSettings.accessLevel.withLinkView": "This content is publicly available to anyone with the link, and can be viewed.",
  "boxui.share.sharedLinkSettings.accessLevel.withLinkViewDownload": "This content is publicly available to anyone with the link, and can be viewed or downloaded.",
  "boxui.share.sharedLinkSettings.allowDownloadLabel": "Allow users with the shared link to download this item",
  "boxui.share.sharedLinkSettings.allowDownloadTitle": "Allow Download",
  "boxui.share.sharedLinkSettings.customURLLabel": "Non-private custom URL",
  "boxui.share.sharedLinkSettings.directDownloadBlockedByAccessPolicyWithClassification": "Download has been disabled for content due to the classification.",
  "boxui.share.sharedLinkSettings.directDownloadBlockedByAccessPolicyWithoutClassification": "Download has been disabled for content without classification.",
  "boxui.share.sharedLinkSettings.directDownloadBlockedByMaliciousContent": "Download for this content has been disabled due to a security policy.",
  "boxui.share.sharedLinkSettings.directLinkLabel": "Direct Link",
  "boxui.share.sharedLinkSettings.expirationLabel": "Disable Shared Link on",
  "boxui.share.sharedLinkSettings.expirationTitle": "Link Expiration",
  "boxui.share.sharedLinkSettings.inaccessibleSettingsNotice": "Certain settings may not be available for this item due to permissions.",
  "boxui.share.sharedLinkSettings.modalTitle": "Shared Link Settings",
  "boxui.share.sharedLinkSettings.passwordLabel": "Require password",
  "boxui.share.sharedLinkSettings.passwordPlaceholder": "Enter a password",
  "boxui.share.sharedLinkSettings.passwordTitle": "Password Protect",
  "boxui.share.sharedLinkSettings.sharedLinkSettingWarningLinkText": "Learn more about shared link settings.",
  "boxui.share.sharedLinkSettings.sharedLinkWarningText": "This content is publicly available to anyone with the link.",
  "boxui.share.sharedLinkSettings.vanityNameNotSet": "The custom URL has not been set",
  "boxui.share.sharedLinkSettings.vanityNamePlaceholder": "Enter a custom path (12 or more characters)",
  "boxui.share.sharedLinkSettings.vanityURLWarning": "Custom URLs should not be used when sharing sensitive content.",
  "boxui.share.sharedLinkURLLabel": "URL",
  "boxui.share.vanityURLEnableText": "Publish content broadly with a custom, non-private URL",
  "boxui.unifiedShare.collabAccess": "collaborator access",
  "boxui.unifiedShare.collaboration.groupCollabText": "Group",
  "boxui.unifiedShare.collaboration.userCollabText": "User",
  "boxui.unifiedShare.collaboratorListTitle": "People in ‘{itemName}’",
  "boxui.unifiedShare.collaborators.expirationTooltipClickableText": "Access expires on {date}. Click for details.",
  "boxui.unifiedShare.contactEmailsTooltipText": "{emails}, and {remainingEmailsCount} more",
  "boxui.unifiedShare.contactRestrictionNotice": "{count, plural, one {{count} invitation} other {{count} invitations}} cannot be sent because external collaboration is restricted due to the applied security policy.",
  "boxui.unifiedShare.contactRestrictionNoticeInformationBarrier": "{count, plural, one {{count} invitation} other {{count} invitations}} cannot be sent due to a security policy.",
  "boxui.unifiedShare.contactRestrictionNoticeInformationBarrierSingular": "Invitations cannot be sent to {email} due to a security policy.",
  "boxui.unifiedShare.contactRestrictionNoticeInformationBarrierSingularGroup": "Invitations cannot be sent to \"{groupName}\" due to a security policy.",
  "boxui.unifiedShare.contactRestrictionNoticeSingular": "Invitations cannot be sent to {email} because external collaboration is restricted due to the applied security policy.",
  "boxui.unifiedShare.contactRestrictionRemoveButtonLabel": "Remove to continue",
  "boxui.unifiedShare.contactsExceedLimitError": "Oops! The maximum number of collaborators that can be added at once is {maxContacts} collaborators. Please try again by splitting your invitations into batches.",
  "boxui.unifiedShare.contentSharedWithExternalCollaborators": "This content will be shared with external collaborators.",
  "boxui.unifiedShare.coownerLevelButtonLabel": "Invite as Co-owner",
  "boxui.unifiedShare.coownerLevelDescription": "Manage security, upload, download, preview, share, edit, and delete",
  "boxui.unifiedShare.coownerLevelText": "Co-owner",
  "boxui.unifiedShare.disabledCreateLinkTooltip": "You do not have permission to create the link.",
  "boxui.unifiedShare.disabledMaliciousContentShareLinkPermission": "This option isn’t available for this item due to a security policy.",
  "boxui.unifiedShare.disabledShareLinkPermission": "This option is not available due to a security policy.",
  "boxui.unifiedShare.editorLevelButtonLabel": "Invite as Editor",
  "boxui.unifiedShare.editorLevelDescription": "Upload, download, preview, share, edit, and delete",
  "boxui.unifiedShare.editorLevelFileDescription": "Upload, download, preview, share, and edit",
  "boxui.unifiedShare.editorLevelText": "Editor",
  "boxui.unifiedShare.emailModalTitle": "Send Link to ‘{itemName}’",
  "boxui.unifiedShare.enterAtLeastOneEmail": "Enter at least one valid email",
  "boxui.unifiedShare.enterEmailAddressesCalloutText": "Share this item with coworkers by entering their email addresses",
  "boxui.unifiedShare.expiresMessage": "Expires",
  "boxui.unifiedShare.ftuxConfirmLabel": "Got it",
  "boxui.unifiedShare.ftuxEditPermissionTooltipBody": "Select the new edit option to easily share your file with people or groups.",
  "boxui.unifiedShare.ftuxEditPermissionTooltipTitle": "Collaboration made easy",
  "boxui.unifiedShare.ftuxLinkText": "Read more about shared link security here.",
  "boxui.unifiedShare.ftuxNewUSMUserBody": "We’ve simplified the sharing experience when you click 'Share'. Invite people to this item here and toggle the link on or off below for easy sharing.",
  "boxui.unifiedShare.ftuxNewUsmUserTitle": "Simplified sharing for files and folders",
  "boxui.unifiedShare.ftuxSharedLinkPermissionsEditTag": "NEW",
  "boxui.unifiedShare.groupLabel": "Group",
  "boxui.unifiedShare.inviteDisabledTooltip": "You do not have permission to invite collaborators.",
  "boxui.unifiedShare.inviteDisabledWeblinkTooltip": "Collaborators cannot be added to bookmarks.",
  "boxui.unifiedShare.inviteFieldLabel": "Invite People",
  "boxui.unifiedShare.justifiableContactRestrictionNotice": "This content requires a business justification for {count, plural, one {{count} invitation} other {{count} invitations}}. Please select a business justification below.",
  "boxui.unifiedShare.justifiableContactRestrictionNoticeSingular": "This content requires a business justification to invite {email}. Please select a business justification below.",
  "boxui.unifiedShare.justifiableContactRestrictionRemoveButtonLabel": "Alternatively, remove to continue",
  "boxui.unifiedShare.justificationRequiredError": "Select a justification or remove to continue",
  "boxui.unifiedShare.justificationSelectPlaceholder": "Select Justification",
  "boxui.unifiedShare.levelOfCollabAccess": "Set the level of {collaboratorAccess} and increase security through one of our paid plans. {upgradeLink}",
  "boxui.unifiedShare.linkShareOff": "Create shared link",
  "boxui.unifiedShare.linkShareOn": "Shared link is created",
  "boxui.unifiedShare.message": "Message",
  "boxui.unifiedShare.modalTitle": "Share ‘{itemName}’",
  "boxui.unifiedShare.peopleInCompanyCanAccessFile": "Anyone in your company with the link or people invited to this file can access",
  "boxui.unifiedShare.peopleInCompanyCanAccessFolder": "Anyone in your company with the link or people invited to this folder can access",
  "boxui.unifiedShare.peopleInCompanyCanAccessHub": "Anyone in your company with the link or people invited to this hub can access",
  "boxui.unifiedShare.peopleInEnterpriseName": "People in {enterpriseName}",
  "boxui.unifiedShare.peopleInItemCanAccessFile": "Only invited people can access this file",
  "boxui.unifiedShare.peopleInItemCanAccessFolder": "Only invited people can access this folder",
  "boxui.unifiedShare.peopleInItemCanAccessHub": "Only invited people can access this hub",
  "boxui.unifiedShare.peopleInSpecifiedCompanyCanAccessFile": "Anyone at {company} with the link or people invited to this file can access",
  "boxui.unifiedShare.peopleInSpecifiedCompanyCanAccessFolder": "Anyone at {company} with the link or people invited to this folder can access",
  "boxui.unifiedShare.peopleInSpecifiedCompanyCanAccessHub": "Anyone at {company} with the link or people invited to this hub can access",
  "boxui.unifiedShare.peopleInThisFile": "Invited people only",
  "boxui.unifiedShare.peopleInThisFolder": "Invited people only",
  "boxui.unifiedShare.peopleInYourCompany": "People in your company",
  "boxui.unifiedShare.peopleWithLinkDescription": "Publicly accessible and no sign-in required",
  "boxui.unifiedShare.peopleWithTheLinkText": "People with the link",
  "boxui.unifiedShare.previewerLevelButtonLabel": "Invite as Previewer",
  "boxui.unifiedShare.previewerLevelDescription": "Preview only",
  "boxui.unifiedShare.previewerLevelText": "Previewer",
  "boxui.unifiedShare.previewerUploaderLevelButtonLabel": "Invite as Previewer Uploader",
  "boxui.unifiedShare.previewerUploaderLevelDescription": "Upload and preview",
  "boxui.unifiedShare.previewerUploaderLevelText": "Previewer Uploader",
  "boxui.unifiedShare.recommendedSharingTooltipCalloutText": "Based on your usage, we think {fullName} would be interested in this file.",
  "boxui.unifiedShare.removeLinkConfirmationDescription": "This will permanently remove the shared link. If this item is embedded on other sites it will also become inaccessible. Any custom properties, settings and expirations will be removed as well. Do you want to continue?",
  "boxui.unifiedShare.removeLinkConfirmationTitle": "Remove Shared Link",
  "boxui.unifiedShare.removeLinkTooltip": "You do not have permission to remove the link.",
  "boxui.unifiedShare.restrictedContactsError": "Remove to continue",
  "boxui.unifiedShare.sendSharedLink": "Send Shared Link",
  "boxui.unifiedShare.sendSharedLinkFieldLabel": "Email Shared Link",
  "boxui.unifiedShare.sharedLinkDisabledTooltipCopy": "Create and copy link for sharing",
  "boxui.unifiedShare.sharedLinkEditablePubliclyAvailable": "Publicly available for anyone to view and download. Any logged in users with the link can edit.",
  "boxui.unifiedShare.sharedLinkElevatedEditableCompanyAvailable": "People who have access to this link can edit.",
  "boxui.unifiedShare.sharedLinkExpirationTooltip": "This link will expire and be inaccessible on {expiration, date, long}.",
  "boxui.unifiedShare.sharedLinkPermissionsEdit": "Can edit",
  "boxui.unifiedShare.sharedLinkPermissionsEditTooltip": "This permission can only be changed in Box Notes",
  "boxui.unifiedShare.sharedLinkPermissionsViewDownload": "Can view and download",
  "boxui.unifiedShare.sharedLinkPermissionsViewOnly": "Can view only",
  "boxui.unifiedShare.sharedLinkPubliclyAvailable": "This content is publicly available to anyone with the link.",
  "boxui.unifiedShare.sharedLinkSectionLabel": "Share Link",
  "boxui.unifiedShare.sharedLinkSettings": "Link Settings",
  "boxui.unifiedShare.sharedLinkSettingsCalloutText": "Create a custom URL, enable password protection, enable link expiration, and much more",
  "boxui.unifiedShare.suggestedCollabsTitle": "Suggested",
  "boxui.unifiedShare.upgradeGetMoreAccessControlsDescription": "62% of customers on your plan {upgradeGetMoreAccessControlsLink} to manage collaborators’ access and permission settings",
  "boxui.unifiedShare.upgradeGetMoreAccessControlsLink": "upgrade",
  "boxui.unifiedShare.upgradeInlineNoticeTitle": "Upgrade Your Plan",
  "boxui.unifiedShare.upgradeLink": "Upgrade now",
  "boxui.unifiedShare.uploaderLevelButtonLabel": "Invite as Uploader",
  "boxui.unifiedShare.uploaderLevelDescription": "Upload only",
  "boxui.unifiedShare.uploaderLevelText": "Uploader",
  "boxui.unifiedShare.viewerLevelButtonLabel": "Invite as Viewer",
  "boxui.unifiedShare.viewerLevelDescription": "Download, preview, and share",
  "boxui.unifiedShare.viewerLevelText": "Viewer",
  "boxui.unifiedShare.viewerUploaderLevelButtonLabel": "Invite as Viewer Uploader",
  "boxui.unifiedShare.viewerUploaderLevelDescription": "Upload, download, preview, share, and edit",
  "boxui.unifiedShare.viewerUploaderLevelText": "Viewer Uploader",
  "boxui.validation.URLError": "Invalid URL",
  "boxui.validation.emailError": "Invalid Email Address",
  "boxui.validation.genericError": "Invalid Input",
  "boxui.validation.invalidDateError": "Invalid Date",
  "boxui.validation.invalidUserError": "Invalid User",
  "boxui.validation.requiredError": "Required Field",
  "boxui.validation.tooLongError": "Input cannot exceed {max} characters",
  "boxui.validation.tooShortError": "Input must be at least {min} characters"
}